module.exports = __webpack_public_path__ + "img/SL-M-180-250.564ab321.svg";